module.exports = __webpack_public_path__ + "img/SL-M-200-250.0c12c99e.svg";